import { Component, Input, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { AbstractControl } from '@angular/forms';
import { allowOnlyXCharsAndMaxNumber } from '@digilize/shared/utils/helpers/src';

@Component({
  selector: 'lib-hour-input',
  templateUrl: './hour-input.component.html',
  styleUrls: ['./hour-input.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class HourInputComponent implements OnInit {
  @Input() minutesControl;
  @Input() hoursControl;
  @Input() secondsControl;
  @Input() maxHours = 99;
  @Input() padding = '9px 8px';
  @Input() fontSize = '12px';
  @Input() icon = false;

  timeInput;

  ngOnInit() {
    if (
      this.hoursControl &&
      this.hoursControl?.value?.toString()?.length < 2 &&
      (this.hoursControl?.value < 10 || !this.hoursControl?.value)
    ) {
      this.hoursControl.setValue('0' + (this.hoursControl.value || 0));
    }

    if (
      this.minutesControl &&
      this.minutesControl?.value?.toString()?.length < 2 &&
      (this.minutesControl?.value < 10 || !this.minutesControl?.value)
    ) {
      this.minutesControl.setValue('0' + (this.minutesControl.value || 0));
    }

    if (
      this.secondsControl &&
      this.hoursControl?.value?.toString()?.length < 2 &&
      (this.secondsControl?.value < 10 || !this.secondsControl?.value)
    ) {
      this.secondsControl.setValue('0' + (this.secondsControl.value || 0));
    }
  }

  onInputClick(event, hoursInput?) {
    // const val = event.target.value;
    // event.target.value = '';
    // event.target.value = val;
    // console.log(event.target);
    const input = event.target as HTMLInputElement;
    input.select();
    // this.timeInput = hoursInput;

    // console.log(hoursInput);
    // setTimeout(() => {
    //   this.timeInput.focus();
    //   hoursInput.focus();
    //   // event.target.focus();
    // }, 0);
  }

  allowOnlyXCharsAndMaxNumber(
    control: AbstractControl,
    secondsInput: HTMLInputElement,
    maxChars: number,
    maxNumber: number
  ) {
    return allowOnlyXCharsAndMaxNumber(control, secondsInput, maxChars, maxNumber);
  }
}
